import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=747c46c8&scoped=true&lang=pug"
import script from "./TenantList.vue?vue&type=script&lang=js"
export * from "./TenantList.vue?vue&type=script&lang=js"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=747c46c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c46c8",
  null
  
)

export default component.exports